import { memo } from "react"

const IconCalendarSimple = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        id="Calendar"
        d="M5.15472 2.49999V3.24999H5.90472H10.0952H10.8452V2.49999V1.58332C10.8452 1.57203 10.8486 1.54071 10.8958 1.49945C10.9444 1.4569 11.0293 1.41666 11.1428 1.41666C11.2564 1.41666 11.3413 1.4569 11.3899 1.49945C11.437 1.54071 11.4404 1.57203 11.4404 1.58332V2.49999V3.24999H12.1904H13.7619C14.3125 3.24999 14.5833 3.62084 14.5833 3.87499V4.49999H1.41663V3.87499C1.41663 3.62074 1.68718 3.24999 2.23805 3.24999H3.80948H4.55948V2.49999V1.58332C4.55948 1.57203 4.56292 1.54071 4.61005 1.49945C4.65865 1.4569 4.74356 1.41666 4.8571 1.41666C4.97065 1.41666 5.05555 1.4569 5.10415 1.49945C5.15128 1.54071 5.15472 1.57203 5.15472 1.58332V2.49999ZM14.5833 13.9583C14.5833 14.2123 14.3124 14.5833 13.7619 14.5833H2.23805C1.68728 14.5833 1.41663 14.2124 1.41663 13.9583V6.91666H14.5833V13.9583Z"
        stroke="#002C98"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default memo(IconCalendarSimple)
